import { render, staticRenderFns } from "./addBorrowInfo.vue?vue&type=template&id=1e4e7287&scoped=true&"
import script from "./addBorrowInfo.vue?vue&type=script&lang=js&"
export * from "./addBorrowInfo.vue?vue&type=script&lang=js&"
import style0 from "./addBorrowInfo.vue?vue&type=style&index=0&id=1e4e7287&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e7287",
  null
  
)

export default component.exports